/**
 * @generated SignedSource<<27d382f2b6c0bc1d0b85b944d75f92a3>>
 * @relayHash 1a9998291b53a2edc745b910e59f5cc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f2da7ae2ed0b1ee1e606039820b8200d4c36951cf6304fdc32c868b41f58187

import type { ConcreteRequest } from 'relay-runtime';
export type AggRovoCleanUpTeamsNudgeAggQuery$variables = {
  isCleanUpTeamsRovoSkillEnabled: boolean;
  scopeId: string;
  userTeamQuery: string;
};
export type AggRovoCleanUpTeamsNudgeAggQuery$data = {
  readonly team?: {
    readonly teamsTql: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
    } | null;
  } | null;
};
export type AggRovoCleanUpTeamsNudgeAggQuery = {
  response: AggRovoCleanUpTeamsNudgeAggQuery$data;
  variables: AggRovoCleanUpTeamsNudgeAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCleanUpTeamsRovoSkillEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userTeamQuery"
},
v3 = [
  {
    "condition": "isCleanUpTeamsRovoSkillEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              },
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "userTeamQuery"
              },
              {
                "kind": "Variable",
                "name": "scopeId",
                "variableName": "scopeId"
              }
            ],
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggRovoCleanUpTeamsNudgeAggQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggRovoCleanUpTeamsNudgeAggQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "4f2da7ae2ed0b1ee1e606039820b8200d4c36951cf6304fdc32c868b41f58187",
    "metadata": {},
    "name": "AggRovoCleanUpTeamsNudgeAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2794f8a7e4d90e4afcfe4919eaefc4f0";

export default node;
